import { FieldGroup } from '@ver-uds/react';
import { Account, MouTemplateType } from 'eve-account-client';
import { format as formatDate } from 'date-fns';
import React from 'react';
import { AuthFileLinkProps } from '../../AuthFileLink';

export type MouLinkType = MouTemplateType | string;

export interface CompanyAccessMyI9Props {
  accountData?: Pick<Account, 'myI9'>;
  linkToMyI9TOS?: React.ReactElement<AuthFileLinkProps<MouLinkType>>;
  companyName: () => string;
}

const CompanyAccessMyI9 = ({
  accountData,
  linkToMyI9TOS = undefined,
  companyName,
}: CompanyAccessMyI9Props): JSX.Element => {
  const MyI9EnabledField = (): JSX.Element => {
    return (
      <FieldGroup.Field className="tablet:grid-col-6" name={`${companyName()} has enabled:`}>
        E-Verify+
      </FieldGroup.Field>
    );
  };

  const MyI9TOSField = (): JSX.Element => {
    return (
      <FieldGroup.Field className="tablet:grid-col-6" name="Terms of Service">
        {linkToMyI9TOS || '---'}
      </FieldGroup.Field>
    );
  };

  const MyI9EnabledBy = (): JSX.Element => {
    const firstName = accountData?.myI9?.signedUserFirstName;
    const middleInitial = accountData?.myI9?.signedUserMiddleInitial;
    const lastName = accountData?.myI9?.signedUserLastName;
    const signedDate = accountData?.myI9?.signedDate;
    if (firstName || lastName) {
      return (
        <FieldGroup.Field className="tablet:grid-col-6" name="E-Verify+ enabled by:">
          {`${firstName ? `${firstName} ` : ''}${middleInitial ? `${middleInitial}. ` : ''}${
            lastName ? `${lastName} ` : ''
          }${signedDate ? `(${formatDate(signedDate, 'MMM dd, yyyy')})` : ''}`}
        </FieldGroup.Field>
      );
    }
    if (!(firstName || lastName) && signedDate) {
      return (
        <FieldGroup.Field className="tablet:grid-col-6" name="E-Verify+ enabled by:">
          {`--- ${`(${formatDate(signedDate, 'MMM dd, yyyy')})`}`}
        </FieldGroup.Field>
      );
    }
    return (
      <FieldGroup.Field className="tablet:grid-col-6" name="E-Verify+ enabled by:">
        ---
      </FieldGroup.Field>
    );
  };

  return (
    <>
      <MyI9EnabledField />
      <MyI9TOSField />
      <MyI9EnabledBy />
    </>
  );
};

export default CompanyAccessMyI9;
